import "./App.css";
import Nav from "./Nav";
import { Home } from "./Pages/Home/index.js";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
